'use strict';

var base = require('base/product/base');
var likes = require('likes/likes/likes');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 * @param {boolean} isNotifyMe is notify me enable
 */
function processSwatchValues(attr, $productContainer, msgs, isNotifyMe) {
    var $attr = '[data-attr="' + attr.id + '"] .swatch-value';
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            $($attr).parents('.attribute').find('.selected-attribute').html(attrValue.displayValue);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');
        $swatchButton.removeClass('disabled unselectable');
        $swatchButton.closest('.priceColorGroupBar').removeClass('d-none');
        if (!isNotifyMe && !attrValue.selectable) {
            $swatchButton.addClass('disabled unselectable');
            if (!$swatchButton.siblings('button').length) $swatchButton.closest('.priceColorGroupBar').addClass('d-none');
        }

        $attrValue.addClass(isNotifyMe || attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {boolean} isNotifyMe is notify me enable
 */
function processNonSwatchValues(attr, $productContainer, isNotifyMe) {
    var $attr = '[data-attr="' + attr.id + '"] .attribute-tiles';

    attr.values.forEach(function (attrValue) {
        var attrUrl = attrValue.selected ? attr.resetUrl : attrValue.url;
        var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');

        $attrValue
            .data('value', attrUrl)
            .removeClass('is-notify-me')
            .removeClass('disabled');

        if (!isNotifyMe && !attrValue.selectable) {
            $attrValue.addClass('disabled');
        } else if (isNotifyMe && !attrValue.selectable) {
            $attrValue.addClass('is-notify-me');
        }


        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $($attr).parents('.attribute').find('.selected-attribute').html(attrValue.displayValue);
        } else {
            $attrValue.removeClass('selected');
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 * @param {boolean} isNotifyMe is notify me enable
 */
function updateAttrs(attrs, $productContainer, msgs, isNotifyMe) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs, isNotifyMe);
        } else {
            processNonSwatchValues(attr, $productContainer, isNotifyMe);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 *
 * @param {Object} response server response
 * @param {Object} $productContainer carousel container jquery object
 */
function createCarousel(response, $productContainer) {
    if ($productContainer.hasClass('product-quickview')) {
        $productContainer
            .find('.js-quickview-images-wrapper')
            .html(response.quickViewImageCarouselHtml);
        $('body').trigger('quickViewCarousel:created', {
            carousel: $productContainer.find('.js-quick-view-images')
        });
    } else {
        $('.js-image-carousel-images').html(response.imageCarouselHtml);
        $('body').trigger('pdpCarousel:created');
    }
}

/**
 *
 * @param {Object} response server response
 * @param {Object} $productContainer carousel container jquery object
 */
function imagePreview(response, $productContainer) {
    $productContainer.find('.image-preview').html(response.imagePreviewHtml);
    $('body').trigger('pdpCarousel:created');
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    $('body').trigger('product:variantChanged', response);
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources, response.product.notifyMeEnabled);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    createCarousel(response, $productContainer);
    // Update PDP bundle image preview
    if ($productContainer.hasClass('set-item')) {
        imagePreview(response, $productContainer);
    }

    // update product callouts
    if (response.calloutDetailHtml) {
        var $calloutContainer = $productContainer.find('.product-details-name .text-product-tag');
        $calloutContainer.replaceWith(response.calloutDetailHtml);
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
        $('.js-notify-me').trigger('product:updateVariationSelection', { product: response.product, $productContainer: $productContainer });
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));

    // update Apple Button
    if ($('.apple-pay-pdp').length > 0) {
        if (response.product.hasAllVariantSelections && response.product.available) {
            $('.apple-pay-pdp').removeClass('d-none');
        } else {
            $('.apple-pay-pdp').addClass('d-none');
        }
        $('.apple-pay-pdp').attr('sku', response.product.id);
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        var queryString = window.location.search;
        var cgidRegex = new RegExp('tileCgid=([^&]*)', '');
        var cgidRegexMatches = cgidRegex.exec(queryString);
        if (cgidRegexMatches && cgidRegexMatches.length === 2) {
            var tileCgid = cgidRegexMatches[1];
            // eslint-disable-next-line no-param-reassign
            selectedValueUrl += (selectedValueUrl.indexOf('?') !== -1 ? '&' : '?') + 'tileCgid=' + tileCgid;
        }
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                likes.guestLikes();
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'

        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '<div class="modal-body bonus-product-modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

var populateMiniCart = function (response) {
    var url = $('.minicart').data('action-url');
    var count = parseInt($('.minicart .minicart-quantity').text(), 10);
    var duration = 6000;

    if (count !== 0 && $('.minicart .popover.show').length === 0) {
        if ($(window).innerWidth() < 768) {
            var mobileUrl = $('#mobileMiniCartModal').data('action-url');
            if (response && response.productAdded) {
                if (response.productAdded.price) {
                    var prdPrice = response.productAdded.price.sales.formatted;
                    $('#mobileMiniCartModal .product-price p').html(prdPrice);
                }
                if (response.productAdded.variationAttributes.length) {
                    var prdSize = response.productAdded.variationAttributes[0].displayValue || '';
                    var prdColor = response.productAdded.variationAttributes[1].displayValue || '';
                    var prdAttrs = $('#mobileMiniCartModal p.line-item-attributes');
                    if (prdSize) $(prdAttrs[0]).html(prdSize);
                    if (prdColor) $(prdAttrs[1]).html(prdColor);
                }
                if (response.productAdded.images) {
                    var prdImg = response.productAdded.images.xs[0].url || '';
                    if (prdImg) $('#mobileMiniCartModal .item-image img').attr('src', prdImg);
                }
            }
            $('#mobileMiniCartModal').modal();

            $.get(mobileUrl, function (mobileMiniCartData) {
                $('.minicart-pp-btn').remove();
                $('#mobileMiniCartModal .modal-content').append(mobileMiniCartData);
                $('body').trigger('miniCartCarousel:init');
                $.spinner().stop();
            });

            if (!$('html').hasClass('un-assistive')) {
                setTimeout(function () {
                    $('#mobileMiniCartModal').find('.close').trigger('click');
                }, duration);
            }
        } else {
            $('.minicart .popover').addClass('show');
            // $('.minicart .popover').spinner().start();

            $.get(url, function (miniCartData) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(miniCartData);
                $('body').trigger('miniCartCarousel:init');
                $.spinner().stop();
            });

            $('.desktop-mini-cart').removeClass('d-none');
            $('.mobile-mini-cart').addClass('d-md-none');

            if (!$('html').hasClass('un-assistive')) {
                setTimeout(function () {
                    $('.minicart .popover').removeClass('show');
                    $('.modal-background').removeClass('d-block');
                }, duration);
            }
        }
    }
};

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        populateMiniCart(response);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

var exportBase = $.extend({}, base, {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
        handlePostCartAdd: handlePostCartAdd,
        updateAttrs: updateAttrs
    },
    addToCart: function () {
        $('body').on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            if ($('.js-pdp-bopis-input').is(':checked')) {
                $('.js-pdp-bopis-btn').trigger('click');
            } else {
                var unselectedAttributes = [];
                var addToCartUrl;
                var pid;
                var pidsObj;
                var setPids;
                var variantSelections = $(this).data('variantSelections') || [];
                var selectedOptions = {
                    product_id: $(this).data('pid'),
                    pname: $(this).data('pname'),
                    brand: $(this).data('brand'),
                    price: $(this).data('price'),
                    Quantity: $(this).data('quantity'),
                    category: $(this).data('category'),
                    product_color: $(this).data('product_color'),
                    bopis: 'no',
                    discount: $(this).data('discount'),
                    product_sku: $(this).data('product_sku'),
                    markdown_type: undefined,
                    product_dept: $(this).data('product_department'),
                    product_division: $(this).data('product_division'),
                    product_subdept: $(this).data('product_subdepartment'),
                    order_type: 'standard order'
                };

                $(document).trigger('addToCart', {
                    selectedOptions: selectedOptions
                });

                if (!$(this).data('isOrderable') && !$('.set-items').length && !$(this).hasClass('js-quick-shop-cart-btn')) {
                    variantSelections.forEach(function (variant) {
                        if (!variant.isSelected) {
                            unselectedAttributes.push(variant.displayName);
                        }
                    });

                    $('.availability-error-message').html('Please Select A ' + unselectedAttributes.join(','));
                } else {
                    $('body').trigger('product:beforeAddToCart', this);

                    if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                        setPids = [];

                        $('.product-detail').each(function () {
                            if (!$(this).hasClass('product-set-detail')) {
                                setPids.push({
                                    pid: $(this).find('.product-id').text(),
                                    qty: $(this).find('.quantity-select').val(),
                                    options: getOptions($(this))
                                });
                            }
                        });
                        pidsObj = JSON.stringify(setPids);
                    }

                    pid = getPidValue($(this));

                    var $productContainer = $(this).closest('.product-detail');
                    if (!$productContainer.length) {
                        $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
                    }

                    addToCartUrl = getAddToCartUrl();

                    var form = {
                        pid: pid,
                        pidsObj: pidsObj,
                        childProducts: getChildProducts(),
                        quantity: $(this).data('quantity') || getQuantitySelected($(this))
                    };

                    var params = location.search.length
                        ? location.search.split('?')[1].split('&')
                        : [];

                    params.forEach(function (param) {
                        if (param.indexOf('tileCgid') !== -1) {
                            form.tileCgid = param.split('=')[1];
                        }
                    });

                    if (!$('.bundle-item').length) {
                        form.options = getOptions($productContainer);
                    }

                    if ($(this).data('flag')) form.flag = $(this).data('flag').replace('$', (form.pid + '').substring(2, 5));

                    $(this).trigger('updateAddToCartFormData', form);
                    if (addToCartUrl) {
                        $.ajax({
                            url: addToCartUrl,
                            method: 'POST',
                            data: form,
                            success: function (data) {
                                handlePostCartAdd(data);
                                $('body').trigger('product:afterAddToCart', data);
                                selectedOptions.discount = data.productAdded ? data.productAdded.getDiscount : '';
                                selectedOptions.price = data.productAdded ? data.productAdded.price.sales.formatted : '';
                                selectedOptions.product_sku = data.productAdded ? data.productAdded.id : '';
                                selectedOptions.category = data.productAdded ? data.productAdded.primaryCategory : '';
                                selectedOptions.product_color = data.productAdded && data.productAdded.variationAttributes.length > 1 ? data.productAdded.variationAttributes[1].displayValue : '';
                                $('body').trigger('event:AddToCart', selectedOptions);
                                $.spinner().stop();
                                miniCartReportingUrl(data.reportingURL);
                            },
                            error: function (err) {
                                var errorMsg = 'Something went wrong, please try again.';
                                if (err && err.responseJSON && err.responseJSON.errorMessage) {
                                    errorMsg = err.responseJSON.errorMessage;
                                }

                                $('.add-to-cart-error-container').text(errorMsg);
                                $.spinner().stop();
                            }
                        });
                    }
                }
            }
        });

        $('body').on('click', 'input[name="pdp-ship"]', function () {
            if ($(this).hasClass('js-pdp-bopis-input')) {
                $('.apple-pay-pdp').addClass('d-none');
            } else if ($('.apple-pay-pdp').length > 0) {
                $('.apple-pay-pdp').removeClass('d-none');
            }
        });
    },
    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },
    updateColorDataAttributeForPDP: function () {
        $(document).on('click', '.color-value', function () {
            var $selectedColor = $(this).data('data-attr-display-value');
            $('.js-product-details').setAttribute($selectedColor);
        });
    },
    selectAttributeTile: function () {
        $(document).on('click', '.attribute-tiles .attribute-tile', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect($(this).data('value'), $productContainer);
        });
    },
    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer);
            }
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');
                        $('.minicart-quantity').html(data.totalQty);
                        populateMiniCart();
                        if ($('.cart-page').length) {
                            location.reload();
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;

            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');

            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                    + '<div class="selected-pid row py-1 my-2" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="col-11 bonus-product-name" >'
                    + $choiceOfBonusProduct.find('.product-name').html()
                    + '</div>'
                    + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                    + '</div>'
                    ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
                $('#chooseBonusProductModal').animate({ scrollTop: $('#chooseBonusProductModal')[0].scrollHeight }, 300);
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
                $('#chooseBonusProductModal').animate({ scrollTop: $('#chooseBonusProductModal')[0].scrollHeight }, 300);
            }
        });
    }
});

module.exports = exportBase;
